import { useQuery } from 'react-query'
import { useAuth0 } from '../../../../contexts/auth0-context'
import callAPI from '../../../../API/callSecureAPI'
import endpoints from '../../../../API/endpoints'
import { TppColumn } from '../../../TppView/types'

const FIVE_MINUTES = 1000 * 60 * 5

export const useTppColumns = (tppId: string | null | undefined) => {
    const { getTokenSilently, isAuthenticated, isLoading: authLoading } = useAuth0()

    const canFetch = !!tppId && !!getTokenSilently && !!isAuthenticated && !authLoading

    return useQuery<TppColumn[]>(
        ['tppColumns', tppId],
        async () => {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(
                `${endpoints.getTPPColumns.url}/${tppId}`,
                endpoints.getTPPColumns.method,
                token
            )
            return response.data as TppColumn[]
        },
        {
            enabled: canFetch,
            cacheTime: FIVE_MINUTES,
            staleTime: FIVE_MINUTES,
        }
    )
}
